import { AfterViewInit, Component, EventEmitter, Inject, Output } from '@angular/core';

import { Subject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { JobsFilters } from '../entities/jobs-filters.entity';

@Component({
	selector: 'jobs-filters',
	templateUrl: 'jobs-filters.html',
	// styleUrls: ['jobs-filters.css']
})
export class JobsFiltersComponent implements AfterViewInit {
	// Elements de fonctionnements pour l'interface
	resetCommands = new Subject<void>();

	// Valeurs des filtres choisis par l'utilisateur
	filters: JobsFilters = new JobsFilters();

	jobNames: string[] = [
		'changeEtatAccesJob',
		'closeAccesJob',
		'createTarifNegatifAccesJob',
		'deleteAccesJob',
		'demandeValidationAccesJob',
		'invalidateAbsentUsersJob',
		'majStatutPdpGenerauxJob',
		'purgeAccesJob',
		'purgeAccesPlannifieJob',
		'purgeHabilitationJob',
		'purgeLogSystemeExterneJob',
		'purgeMemoJob',
		'purgeMessageCollationeJob',
		'purgePlanPreventionJob',
		'purgeTransfertCacJob',
		'refusAccesJob',
		'requestSignatureJob',
		'updateDonneesIncendiesJob',
		'updateTarifNegatifAccesJob',
	];
	
	
	constructor( //
	) {
		// Le champ perimetre geographique doit aussi etre reset quand une commande de reinitialisation arrive
		this.resetCommands.subscribe(
			() => {
				this.filters = {
					date: null,
					jobName: null, 
				} as JobsFilters;
				this.filterRequest.emit(this.filters);
			}
		)
	}

	// Evenement pour quand l'utilisateur demande l'application des filtres
	@Output() filterRequest = new EventEmitter<JobsFilters>();

	ngAfterViewInit() {
		// NB: Attention! Comme resetCommands est potentiellement bind sur le sous-composant,
		// il faut attendre qu'il ait ete transmis avant d'envoyer le premier signal d'initialisation
		this.resetCommands.next();
	}

	search() {
		this.filterRequest.emit(this.filters);
	}

	resetFilters() {
		this.resetCommands.next();
	}
}